/* ------------------------------------------- */
/*   Queries for coordinator search
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import {
  getRESTQuery,
  postRESTQuery,
} from 'AppSrc/core/queries/axios-queries';

/*
  The upsertWii endpoint accepts an array of wiis. However, the server will make seperate requests
  to TIL for each work item (consecutively), and each of those requests can have a data limit of 5MB.
  Each request to the api can have a maximum of 6MB, so sending all of the wiis in a single array could
  cause errors if the user attaches wiis with a total size of > 6MB.
  After discussing with the server team the easiest solution and best experience for the user
  will be if we send each WII as a single request, and send them all in parallel.
*/
const createWorkInfoItems = (workInfoItemData) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.workInfoItems.create}`;
  let delay = 0;
  const delayIncrement = 1000;
  const promises = workInfoItemData ? workInfoItemData.map((wii) => {
    // send individual wii to upsertWii as an array
    const params = [wii];
    delay += delayIncrement;
    return new Promise((resolve) => setTimeout(resolve, delay)).then(() => postRESTQuery(endpoint, params).then((response) => response.data.results));
  }) : [];
  return Promise.all(promises).then((itemArrays) => {
    // Promise.all returns an array of return values for each promise
    // guaranteeing the results array matches the order of the input promises array.
    // item array will be an array of arrays of objects containing the id `[[{ id: 'abcd123' }... ]]`.
    // to return an array of workItem ids, we just have to flatten this array.
    // IE11 compatible flatten using concat and array spread https://www.jstips.co/en/javascript/flattening-multidimensional-arrays-in-javascript/
    const items = [].concat(...itemArrays);
    return items;
  });
};

const getAttachmentFileData = ({
  crqId,
  fileId,
  network,
}) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.workInfoItems.attachment}`;
  const parameters = {
    crq_id: crqId,
    work_id: fileId,
    network,
  };
  return getRESTQuery(endpoint, parameters).then((response) => {
    const { data } = response;
    return data.data;
  });
};

export { createWorkInfoItems, getAttachmentFileData };
